import React, {
	memo,
	useCallback,
	useMemo,
	useState
} from 'react';
import PropTypes from 'prop-types';
import {
	Grid,
	Popup
} from 'semantic-ui-react';

import { log } from '../../services/utils';

// props.errors = [] ???

const ColorPicker = ( {
	colors,
	name,
	onChange,
	value
} ) => {
	const [ open, setOpen ] = useState( false );

	const handleOpen = useCallback( () => {
		setOpen( true );
	}, [ setOpen ] );

	const handleClose = useCallback( () => {
		setOpen( false );
	}, [ setOpen ] );

	const mapColors = useCallback( () => colors.map( color => {
		const handleChange = () => {
			onChange( {
				target: {
					name,
					value: color
				}
			} );
			setOpen( false );
		};

		const style = {
			width: '28.31px',
			height: '28.31px',
			backgroundColor: color,
			cursor: 'pointer'
		};

		return <Grid.Column
			onClick={ handleChange }
			key={ color }
			style={ style }
		/>;
	} ), [
		colors,
		name,
		onChange
	] );

	const trigger = useMemo(
		() => <div
			style={ {
				flex: '1 0 28.31px',
				backgroundColor: value,
				border: '1px solid rgba(34, 36, 38, 0.15)'
			} }>
		&nbsp;
		</div>,
		[ value ]
	);

	return (
		<>
			{ log( `- ${ name } color picker` ) }
			<Popup
				hoverable
				on="click"
				onClose={ handleClose }
				onOpen={ handleOpen }
				open={ open }
				pinned
				position="bottom center"
				positionFixed
				style={ { padding: '1.5rem' } }
				trigger={ trigger }
			>
				<Grid columns={ 8 }>
					{ mapColors()}
				</Grid>
			</Popup>
		</>
	);
};

ColorPicker.propTypes = {
	colors: PropTypes.array.isRequired,
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.oneOfType( [
		PropTypes.string,
		PropTypes.number,
		PropTypes.array
	] ).isRequired
};

export default memo( ColorPicker );
